import { createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createElementVNode as _createElementVNode, createVNode as _createVNode, withModifiers as _withModifiers, resolveComponent as _resolveComponent, withCtx as _withCtx, createBlock as _createBlock, toDisplayString as _toDisplayString } from "vue"

const _hoisted_1 = { class: "entity-section" }
const _hoisted_2 = { key: 0 }
const _hoisted_3 = { key: 0 }
const _hoisted_4 = ["onClick"]
const _hoisted_5 = ["onClick"]
const _hoisted_6 = ["onClick"]
const _hoisted_7 = {
  key: 0,
  class: "nested-relations"
}
const _hoisted_8 = ["onClick"]
const _hoisted_9 = {
  key: 1,
  class: "warning"
}
const _hoisted_10 = { key: 1 }
const _hoisted_11 = { key: 0 }
const _hoisted_12 = ["onClick"]

export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_RelationSection = _resolveComponent("RelationSection", true)

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createCommentVNode(" Add New Button at the top (only for many relations) "),
    _createCommentVNode(" Many Relations "),
    ($setup.relation.many)
      ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
          ($setup.parent === $setup.parentMovie ? $setup.allEntities.length : $setup.validRelationIds.length)
            ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($setup.parent === $setup.parentMovie ? $setup.allEntities : $setup.validRelationIds.map((id) => $setup.allEntities.find((e) => e.id === id)).filter((e) => e && typeof e === 'object'), (entity) => {
                  return (_openBlock(), _createElementBlock(_Fragment, null, [
                    (entity && ($setup.relationSchema.fields.length ? entity[$setup.relationSchema.fields[0].name] || entity.id : entity.id))
                      ? (_openBlock(), _createBlock($setup["AccordionItem"], {
                          key: entity.id,
                          title: $setup.relationSchema.fields.length ? entity[$setup.relationSchema.fields[0].name] || entity.id : entity.id,
                          id: $setup.relation.type + '-' + entity.id
                        }, {
                          "header-actions": _withCtx(() => [
                            _createElementVNode("button", {
                              onClick: $event => ($setup.openEntityModal('edit', $setup.relation.type, entity, $setup.parent, $setup.parentMovie, $setup.relation.name, (data) => $setup.updateEntity(entity, data))),
                              class: "icon"
                            }, "edit", 8 /* PROPS */, _hoisted_4),
                            ($setup.parent === $setup.parentMovie)
                              ? (_openBlock(), _createElementBlock("button", {
                                  key: 0,
                                  onClick: $event => ($setup.removeEntity(entity.id, $setup.relation.type)),
                                  class: "icon"
                                }, "delete", 8 /* PROPS */, _hoisted_5))
                              : (_openBlock(), _createElementBlock("button", {
                                  key: 1,
                                  onClick: $event => ($setup.removeRelation(entity.id)),
                                  class: "icon"
                                }, "delete", 8 /* PROPS */, _hoisted_6))
                          ]),
                          default: _withCtx(() => [
                            _createVNode($setup["EntityFields"], {
                              class: "entity-fields",
                              entity: entity,
                              fields: $setup.relationSchema.fields
                            }, null, 8 /* PROPS */, ["entity", "fields"]),
                            ($setup.relationSchema.relations)
                              ? (_openBlock(), _createElementBlock("div", _hoisted_7, [
                                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($setup.relationSchema.relations, (nestedRelation) => {
                                    return (_openBlock(), _createBlock($setup["AccordionItem"], {
                                      key: nestedRelation.name + '-' + entity.id,
                                      title: nestedRelation.name.charAt(0).toUpperCase() + nestedRelation.name.slice(1),
                                      id: nestedRelation.type + '-' + entity.id
                                    }, {
                                      "header-actions": _withCtx(() => [
                                        _createElementVNode("button", {
                                          onClick: _withModifiers($event => ($setup.openEntityModal('add', nestedRelation.type, null, entity, $setup.parentMovie, nestedRelation.name, (data) => $setup.createNestedEntity(nestedRelation, entity, $setup.parentMovie, data))), ["stop"]),
                                          class: "icon"
                                        }, " library_add ", 8 /* PROPS */, _hoisted_8)
                                      ]),
                                      default: _withCtx(() => [
                                        _createVNode(_component_RelationSection, {
                                          relation: nestedRelation,
                                          parent: entity,
                                          "parent-movie": $setup.parentMovie,
                                          schema: $setup.schema,
                                          "open-accordion-ids": $setup.openAccordionIds,
                                          "open-entity-modal": $setup.openEntityModal,
                                          onUpdate: _cache[0] || (_cache[0] = $event => (_ctx.$emit('update', $setup.parentMovie)))
                                        }, null, 8 /* PROPS */, ["relation", "parent", "parent-movie", "schema", "open-accordion-ids", "open-entity-modal"])
                                      ]),
                                      _: 2 /* DYNAMIC */
                                    }, 1032 /* PROPS, DYNAMIC_SLOTS */, ["title", "id"]))
                                  }), 128 /* KEYED_FRAGMENT */))
                                ]))
                              : _createCommentVNode("v-if", true)
                          ]),
                          _: 2 /* DYNAMIC */
                        }, 1032 /* PROPS, DYNAMIC_SLOTS */, ["title", "id"]))
                      : _createCommentVNode("v-if", true)
                  ], 64 /* STABLE_FRAGMENT */))
                }), 256 /* UNKEYED_FRAGMENT */))
              ]))
            : (_openBlock(), _createElementBlock("div", _hoisted_9, "No " + _toDisplayString($setup.relation.name) + " added yet", 1 /* TEXT */))
        ]))
      : _createCommentVNode("v-if", true),
    _createCommentVNode(" Single Relations (always show select) "),
    (!$setup.relation.many)
      ? (_openBlock(), _createElementBlock("div", _hoisted_10, [
          ($setup.singleEntity && $setup.singleEntityTitle)
            ? (_openBlock(), _createBlock($setup["AccordionItem"], {
                key: 0,
                title: $setup.singleEntityTitle,
                id: $setup.relation.type + '-' + $setup.singleEntity.id
              }, {
                "header-actions": _withCtx(() => [
                  _createElementVNode("button", {
                    onClick: _cache[1] || (_cache[1] = $event => ($setup.openEntityModal('edit', $setup.relation.type, $setup.singleEntity, $setup.parent, $setup.parentMovie, $setup.relation.name, (data) => $setup.updateEntity($setup.singleEntity, data))))
                  }, "Edit")
                ]),
                default: _withCtx(() => [
                  _createVNode($setup["EntityFields"], {
                    entity: $setup.singleEntity,
                    fields: $setup.relationSchema.fields
                  }, null, 8 /* PROPS */, ["entity", "fields"]),
                  ($setup.relationSchema.relations)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_11, [
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($setup.relationSchema.relations, (nestedRelation) => {
                          return (_openBlock(), _createBlock($setup["AccordionItem"], {
                            key: nestedRelation.name + '-' + $setup.singleEntity.id,
                            title: nestedRelation.name.charAt(0).toUpperCase() + nestedRelation.name.slice(1),
                            id: nestedRelation.type + '-' + $setup.singleEntity.id
                          }, {
                            "header-actions": _withCtx(() => [
                              _createElementVNode("button", {
                                onClick: _withModifiers($event => (
                  $setup.openEntityModal('add', nestedRelation.type, null, $setup.singleEntity, $setup.parentMovie, nestedRelation.name, (data) => $setup.createNestedEntity(nestedRelation, $setup.singleEntity, $setup.parentMovie, data))
                ), ["stop"])
                              }, " Add ", 8 /* PROPS */, _hoisted_12)
                            ]),
                            default: _withCtx(() => [
                              _createVNode(_component_RelationSection, {
                                relation: nestedRelation,
                                parent: $setup.singleEntity,
                                "parent-movie": $setup.parentMovie,
                                schema: $setup.schema,
                                "open-accordion-ids": $setup.openAccordionIds,
                                "open-entity-modal": $setup.openEntityModal,
                                onUpdate: _cache[2] || (_cache[2] = $event => (_ctx.$emit('update', $setup.parentMovie)))
                              }, null, 8 /* PROPS */, ["relation", "parent", "parent-movie", "schema", "open-accordion-ids", "open-entity-modal"])
                            ]),
                            _: 2 /* DYNAMIC */
                          }, 1032 /* PROPS, DYNAMIC_SLOTS */, ["title", "id"]))
                        }), 128 /* KEYED_FRAGMENT */))
                      ]))
                    : _createCommentVNode("v-if", true)
                ]),
                _: 1 /* STABLE */
              }, 8 /* PROPS */, ["title", "id"]))
            : _createCommentVNode("v-if", true)
        ]))
      : _createCommentVNode("v-if", true)
  ]))
}